// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  auditId: __t.u64().primaryKey().name("audit_id"),
  settlementId: __t.u64().name("settlement_id"),
  playerHex: __t.string().name("player_hex"),
  direction: __t.string(),
  commodity: __t.string(),
  qty: __t.i32(),
  sov: __t.i64(),
  coins: __t.i64(),
  at: __t.timestamp(),
});
